import validatePresence from './validatePresence';

const validateAddress = (value: unknown, fieldNames: string[]): string | boolean => validatePresence(value, fieldNames);

export default validateAddress;
